export default __webpack_public_path__ + "static/media/icon5.7ac5bb3a.png";